import { z } from 'zod'
import { ContentfulEntriesRequestParamsSchema } from './request'

export const ContentfulMessageClusterRequestParamsSchema =
  ContentfulEntriesRequestParamsSchema.extend({
    clusters: z.preprocess(
      (val) => (typeof val === 'string' ? val.split(',') : val),
      z.string().array()
    ),
  })
    // NOTE: message cluster doesn't currently do partner specific content
    .omit({ partner: true })

export type ContentfulMessageClusterRequestParams = z.infer<
  typeof ContentfulMessageClusterRequestParamsSchema
>

export const ContentfulMessageSchema = z.object({
  key: z.string(),
  defaultValue: z.string().optional(), // remove optional once schema and content updated in all envs on contentful
  value: z.string().optional(),
  description: z.string().optional(),
})

export type ContentfulMessage = z.infer<typeof ContentfulMessageSchema>

export const ContentfulMessageClusterSchema = z.object({
  key: z.string(),
  messages: ContentfulMessageSchema.array(),
})

export type ContentfulMessageCluster = z.infer<typeof ContentfulMessageClusterSchema>
